import { render, staticRenderFns } from "./MediateHandle.vue?vue&type=template&id=0df9e107&scoped=true&"
import script from "./MediateHandle.vue?vue&type=script&lang=js&"
export * from "./MediateHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df9e107",
  null
  
)

export default component.exports